import { parse as parseDateString, format as formatDate, isDate, isFuture, isPast, isValid } from 'date-fns'
import configHandler from '../configHandler'

const DATE_FORMAT_KEY = 'ddmmyyyy'
const INVALID_DATE_ERROR = 'invalidDate'

const parse = (inputDate) => {
    return {
        input: inputDate,
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        parsed: function () {
            if (isDate(this.input)) {
                return this.input
            }
            if (typeof this.input === 'string') {
                try {
                    const trimmedInput = this.removeSeparators(this.input.trim())
                    const dateFormat = this.removeSeparators(this.getDateFormat())

                    if (trimmedInput.length !== dateFormat.length) {
                        return null
                    }
                    const parsedDate = parseDateString(trimmedInput, dateFormat, new Date())
                    if (isValid(parsedDate)) {
                        return parsedDate
                    }
                } catch (e) {
                    console.warn('Date parsed error. Invalid date format supplied')
                }
                return null
            }
        },

        getDate() {
            return this.parsed()
        },

        getDateFormat: function () {
            return configHandler.getDateFormat(DATE_FORMAT_KEY)
        },

        validate: function () {
            const errors = []
            const parsedDate = this.parsed()
            if (parsedDate === null && this.input.length === 0) {
                if (this.isRequired) {
                    errors.push(configHandler.errorMessages().date[INVALID_DATE_ERROR])
                }
                return errors
            }

            if (!isDate(parsedDate) || !isValid(parsedDate)) {
                errors.push(configHandler.errorMessages().date[INVALID_DATE_ERROR])
            }
            return errors
        },

        isValid: function () {
            return this.validate().length === 0
        },

        isFuture: function () {
            if (!this.isValid()) {
                return false
            }
            return isFuture(this.parsed())
        },

        isPast: function () {
            if (!this.isValid()) {
                return false
            }
            return isPast(this.parsed())
        },

        format: function () {
            if (!this.isValid()) {
                return this.parsed()
            }

            return formatDate(this.parsed(), this.getDateFormat())
        },
        removeSeparators(value) {
            return value
                .replaceAll('.', '')
                .replaceAll('-', '')
                .replaceAll('/', '')
                .replaceAll(' ', '')
        },
    }
}

export default {
    parse,
}